import React from "react";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import DialpadIcon from "@mui/icons-material/Dialpad";
import ContactsIcon from "@mui/icons-material/Contacts";
import HistoryIcon from "@mui/icons-material/History";
import BugReportIcon from "@mui/icons-material/BugReport";
import { useTranslation } from "../i18n/LocaleContext";

export type PanelId = "softphone" | "contacts" | "history" | "events";

interface WorkspaceBottomNavProps {
  value: PanelId;
  onChange: (panel: PanelId) => void;
  showEvents: boolean;
}

/**
 * Barra de navegação do layout mobile (≤720px). Fica sempre no DOM — quem a esconde no
 * desktop é a CSS (.workspace-bottom-nav), para que a troca de painel não dependa de
 * nenhum estado de JS acima do breakpoint.
 */
const WorkspaceBottomNav: React.FC<WorkspaceBottomNavProps> = ({ value, onChange, showEvents }) => {
  const { t } = useTranslation();
  return (
    <nav className="workspace-bottom-nav">
      <BottomNavigation
        value={value}
        onChange={(_event, next: PanelId) => onChange(next)}
        showLabels
        sx={{
          backgroundColor: "transparent",
          height: "auto",
          "& .MuiBottomNavigationAction-root": {
            color: "var(--app-text-secondary)",
            minWidth: 0,
            paddingTop: 1,
            paddingBottom: 0.5,
          },
          "& .Mui-selected": { color: "var(--app-accent-primary)" },
          "& .MuiBottomNavigationAction-label": { fontSize: "0.7rem" },
        }}
      >
        <BottomNavigationAction value="softphone" label={t("workspace.nav.softphone")} icon={<DialpadIcon />} />
        <BottomNavigationAction value="contacts" label={t("workspace.nav.contacts")} icon={<ContactsIcon />} />
        <BottomNavigationAction value="history" label={t("workspace.nav.history")} icon={<HistoryIcon />} />
        {/* A aba só existe em dev e hoje reúne o painel de eventos e o de dispositivos, daí o
            rótulo genérico. O id "events" fica: é o que a CSS usa em data-active-panel. */}
        {showEvents && (
          <BottomNavigationAction value="events" label={t("workspace.nav.events")} icon={<BugReportIcon />} />
        )}
      </BottomNavigation>
    </nav>
  );
};

export default WorkspaceBottomNav;
